module.exports = __webpack_public_path__ + "static/img/yxgl-kj.99c6a99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/yxgl-kj.png
// module id = K7Bu
// module chunks = 0